module.exports = __webpack_public_path__ + "img/flutter.8a50b602.png";